import { Component } from '@angular/core';
import { Block, BlockContainer, BlockType } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';
import { AbstractControl, FormArray, FormBuilder, FormControl, ValidationErrors } from '@angular/forms';

export enum FormControlName {
  blocks = 'blocks',
}

interface BlockContainerForm {
  [FormControlName.blocks]: FormArray<FormControl<Block>>;
}

@Component({
  selector: 'pl-block-container',
  templateUrl: './block-container.component.html',
})
export class BlockContainerComponent extends BlockAbstractComponent<BlockContainer, BlockContainerForm> {
  protected readonly BlockType: typeof BlockType = BlockType;
  protected readonly FormControlName: typeof FormControlName = FormControlName;

  protected override initForm(): void {
    const fb: FormBuilder = new FormBuilder();
    this.form = fb.nonNullable.group<BlockContainerForm>({
      blocks: fb.nonNullable.array<Block>([], this.validateFormArray.bind(this)),
    });
  }
  public get formArrayBlocks(): FormArray {
    if (this.form) {
      return this.form.get(FormControlName.blocks) as FormArray;
    }

    throw new Error(`this.form is not defined, not normal`);
  }

  protected validateFormArray(abstractControl: AbstractControl): ValidationErrors | null {
    const formArray: FormArray<FormControl<Block>> = abstractControl as FormArray;
    let errors: ValidationErrors | null = null;
    for (const control of formArray.controls) {
      if (control.invalid) {
        if (errors !== null) {
          Object.assign(errors, control.errors);
        } else {
          errors = control.errors;
        }
      }
    }
    return errors;
  }

  protected override patchFormWithEmptyValue(): void {
    this.formArrayBlocks.clear({ emitEvent: false });
  }

  protected override patchFormFromBlock(block: BlockContainer): void {
    console.log('TONIO BlockContainerComponent patchFormFromBlock block=', block);
    this.formArrayBlocks.clear({ emitEvent: false });

    block.data.blocks.forEach((value: Block | null) => {
      if (value) {
        value.customCssClass = ['px-5'];
        this.formArrayBlocks.push(new FormControl(value), { emitEvent: false });
      }
    });

    // timeToWait is particularly high here, there was a bug with firefox & Safari
    // where the form valid state was not properly updated after setting the block
    // Giving more time solves the issue (it was 5ms before)
    this.updateValueAndValidityAsync(100);
  }

  protected override getUpdatedBlock(): BlockContainer {
    if (this.form && this.block) {
      const blocksUpdated: Block[] = this.formArrayBlocks.value;

      return {
        ...this.block,
        data: {
          ...this.block.data,
          blocks: blocksUpdated,
        },
      };
    }

    throw new Error(`getUpdatedBlock() this.form or control should not be null when this function is called`);
  }
}
